import intl from 'react-intl-universal';
import { DASHBOARD_DETAIL_ACTIONS } from '../../../../utils/constants/dashboard';
import { useDrillDown } from './hooks/useDrillDown';
import {
  Icon,
  OverflowMenuItem,
  tailwindOverride,
  Typography,
} from '@getsynapse/design-system';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../state/store';
import { cardTypeSelectors } from '../../../../state/normalized/insights/cardTypeSlice';
import { Card } from '../../../../utils/customTypes';
import { GridItemData } from './GridItem';
import { INSIGHT_TO_BASE_DRILLDOWN_KEY } from 'types/store/normalized/insights/InsightCatalogue';

export const ViewInsightDataOverflowItem = (props: {
  gridItemData: GridItemData;
  card: Card;
}) => {
  const { gridItemData, card } = props;
  const { handleDrillDown } = useDrillDown();

  const cardType = useSelector(
    (state: RootState) =>
      // TODO: Handle error case where CardType is not found
      cardTypeSelectors.selectCardTypeById(state, card.cardTypeId)!
  );

  const item = {
    label: intl.get('DASHBOARD_DETAIL.ACTION.VIEW_INSIGHT_DATA'),
    iconName: 'list-outline',
    onSelect: () => {
      handleDrillDown(
        gridItemData.cardType,
        INSIGHT_TO_BASE_DRILLDOWN_KEY[gridItemData.cardType.insightId]
      );
    },
    action: DASHBOARD_DETAIL_ACTIONS.VIEW_INSIGHT_DATA,
  };

  return (
    <OverflowMenuItem
      key={item.label}
      className='flex items-center space-x-2'
      onSelect={item.onSelect}
      data-cy={`insight-${cardType.id}__actions-popover__${item.action}`}
    >
      <Icon
        name={item.iconName || ''}
        className={tailwindOverride(
          'fill-current text-primary group-hover:fill-current group-hover:text-secondary-darker text-lg'
        )}
      />
      <Typography
        variant='label'
        className='group-hover:text-secondary-darker cursor-pointer'
      >
        {item.label}
      </Typography>
    </OverflowMenuItem>
  );
};
